export default "__VITE_ASSET__CJjt3i0F__"